module.exports = __webpack_public_path__ + "build/img/score-rays.04b1309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/score-rays.png
// module id = D81K
// module chunks = 1